module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    class: [(this.$store.state.alertCalendario.alertCalendario.show === true) ? 'in show' : '', 'modal fade'],
    attrs: {
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "back-header modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.fecharModal()
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title alert-title color-h4"
  }, [_vm._v(" Datas fechamento financeiro")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('b-list-group', [_c('b-list-group-item', {
    attrs: {
      "variant": "info"
    }
  }, [_c('strong', [_vm._v("Extra contratual (mês corrente)")])]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("Ciclo de pagamento do dia 21 a 20 de cada mês.")]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("Até dia 25 - Fornecedor envia informações para o fop.")]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("De 25 ao 2º dia útil do mês - Fop envia pagamento para matriz.")]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("Do 2º dia útil ao dia 10 – Matriz cria PC.")]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "variant": "info"
    }
  }, [_c('strong', [_vm._v("SLA (mês anterior)")])]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("Dia 8 – Fechamento SLA SSP.")]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("Dia 8 ao dia 15 – Fop envia notificação para o fornecedor.")]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("Até dia 25 – Fornecedor envia de acordo para multa/glosa.")]), _vm._v(" "), _c('b-list-group-item', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("De 25 ao 2º dia útil do mês - Fop envia multa/glosa para matriz. (Carta informando o mês do SLA (ex.: junho) e o mês do desconto (ex.: julho)).")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        return _vm.fecharModal()
      }
    }
  }, [_vm._v("Fechar")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-97b983a8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/AlertCalendario.vue
// module id = 1017
// module chunks = 1